import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider } from './components/utils/SnackBar';
import { UserProvider } from './services/Context/UserContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <SnackbarProvider>
     <UserProvider>
    <App />
    </UserProvider>
  </ SnackbarProvider>
);
reportWebVitals();